// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper_fee10"};